import { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";

export const SmoothScroll = ({ children }) => {
  const ref = useRef();
  useEffect(() => {
    if (ref.current?.lenis) window.__lenis = ref.current.lenis;
  });
  return (
    <ReactLenis ref={ref} root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      {children}
    </ReactLenis>
  );
};
